(function(angular, schoolwork12) {
    'use strict';

    angular.module(schoolwork12.app.student.name)
        .controller(schoolwork12.app.student.controllers.studentDetails, ['$rootScope', '$scope', '$http', '$timeout', '$location', '$uibModal', '$filter', '$state', '$q',
                schoolwork12.app.auth.services.authentication,
                schoolwork12.app.common.services.eventNotification,
                schoolwork12.app.common.services.utilService,
                schoolwork12.app.student.services.studentAttendanceAdjustmentSvc,
                schoolwork12.app.student.services.manageSchoolDataSvc,
                schoolwork12.app.student.services.studentSearchDetailsNotification,
                'unsavedChanges',

                function($rootScope, $scope, $http, $timeout, $location, $uibModal, $filter, $state, $q,
                    authentication, eventNotification, utilService, studentAttendanceAdjustmentSvc, manageSchoolDataSvc, creTracking, unsavedChanges) {
                    console.info('calling student details Controller:......');
                    eventNotification.subscribe(schoolwork12.app.auth.events.userLoggedIn,
                        function(event, authenticatedUser) {
                            console.info('Student Details controller: Subscribe On UserLogin Event: '
                                .concat(angular.toJson(authenticatedUser)));

                            $scope.stuPlanViewRole = authentication.hasStudentGradPlanViewRole();
                            $scope.stuPlanEditRole = authentication.hasStudentGradPlanEditRole();
                            $scope.hasAttendanceAdjusterRole = authentication.hasAttendanceAdjusterRole();
                            $scope.hasProgParticipantMgrRole = authentication.hasProgParticipantMgrRole();
                        });

                    $scope.forms = {};
                    $scope.editErrorOccurred = false;
                    $scope.showSavedStudentMsg = false;
                    $scope.noDemoErrorsExist = true;
                    $scope.noLanguageErrorsExist = true;

                    $scope.allReasonsList = {};
                    $scope.cteReasonsList = {};
                    $scope.futureReasonsList = {};
                    $scope.dcaType = false;
                    $scope.nullEndDate = false;

                    $rootScope.hideStudentSearch = true;
                    $rootScope.assignedDiplomaSuccessfully = false;
                    $scope.hideStudentDetails = false;
                    $scope.showLegend = false;
                    // changes for Accordion
                    $scope.oneAtATime = true;
                    $scope.editAccordions = {
                        demoData: false,
                        attendanceAdjustment: false,
                        instructionLevels: false,
                        strongStart: false,
                        engagement: false,
                        fast: false,
                        pulseCheck: false,
                        reRegistration: false,
                        actionNeeded: false,
                        opened: true
                    };
                    $scope.toggleView = {show: false};
                    $scope.ctePathway = {};
                    $scope.cteFuture = {};

                    //disable reasons on default
                    $scope.cteNameSelected = false;
                    $scope.futureNameSelected = false;
                    $scope.cteFuture.enableFFReason = false;

                    // changes for FAST Date picker
                    $scope.editFastDatePicker = { opened: false };
                    $scope.openEditFastDatepicker = function() {
                        $scope.editFastDatePicker.opened = true;
                    };
                    $scope.attAdjToRemove = [];
                    // options for Instructional levels
                    $scope.options = [{ value: "Not Assigned" }, { value: "Advanced" }, { value: "Proficient" },
                        { value: "Basic" }, { value: "Below Basic" }, { value: "Not Applicable" }
                    ];

                    $scope.mtssoptions = [{ value: "Not Selected"}, { value: "Tier 2" }, { value: "Tier 3" }]

                    // page refresh redirect to search page
                    if (!$scope.$parent.studentResultsGridObject) {
                        $location.url('/student-search');
                    }

                    //determine student grad plan access based on roles
                    $scope.stuPlanViewRole = authentication.hasStudentGradPlanViewRole();
                    $scope.stuPlanEditRole = authentication.hasStudentGradPlanEditRole();
                    $scope.isStudentGradPlanAccess = ($scope.stuPlanViewRole || $scope.stuPlanEditRole) ? true : false;

                    //getAllReasons
                    $scope.getAllDemoReasons = function(type){
                        $http({
                        url : schoolwork12.app.student.endpoints.reason,
                        method: "GET",
                        params: {
                                    types: type,
                                },
                        headers : {
                                    'X-API-TOKEN': authentication.getCurrentUser().keycode,
                                }
                        })
                        .then(function(response){
                            if(response.data){
                                if(type == 30){
                                    $scope.allReasonsList = response.data;
                                    //console.log("allReasonsList", $scope.allReasonsList)
                                    // $scope.currentReasonsList = angular.copy($scope.allReasonsList);
                                } else if(type == 31){
                                    $scope.cteReasonsList = response.data;
                                    if(!$scope.ctePathway.cteName){
                                        $scope.noCTEName = true;
                                    }
                                    // console.log("cteReasonsList", $scope.cteReasonsList)
                                    // $scope.currentReasonsList = angular.copy($scope.allReasonsList);
                                } else if(type == 32){
                                    $scope.futureReasonsList = response.data;
                                    if(!$scope.cteFuture.futureName){
                                        $scope.noFutureName = true;
                                    }

                                    // console.log("futureReasonsList", $scope.futureReasonsList)
                                    // $scope.currentReasonsList = angular.copy($scope.allReasonsList);
                                }

                            }

                        })
                    }
                 
                    //invoke reasons svc with types params
                    $scope.getAllDemoReasons(30);
                    $scope.getAllDemoReasons(31);
                    $scope.getAllDemoReasons(32);

                    //determine datafields shown Re-Registration Category , ...
                    var dataFieldIdList = [];
                    // Get list of dynamic data fields
                    var getDataFieldsbyStudentSchool = function() {
                        manageSchoolDataSvc.getDataFieldsbySchools(authentication.getCurrentUser().keycode, $filter('filter')(authentication.getSchools(), {schoolId:  $scope.editStudent.schoolId}))
                            .then(function(data, status, headers, config) {
                                var dataFieldsList = data.dataFieldList;
                                $scope.dataFieldListbySchools = dataFieldsList;
                                //check if any of data fields are displayed
                                dataFieldIdList = [];
                                if(data.dataFieldList){
                                    for(var i = 0;  i < dataFieldsList.length; i++){
                                        if (dataFieldsList[i].value == true){
                                            $scope.hasDataFieldShown = true;
                                            dataFieldIdList.push(dataFieldsList[i].id);
                                        }
                                    }
                                }
                            },
                            function(data, status, headers, config) {
                                console.error("ERROR OCCURRED");
                            });
                    }

                    //getAllSchools
                    var getAllSchoolsList = function(){
                        $http({
                        url : schoolwork12.app.student.endpoints.schoolsSearch + '/actSchools/',
                        method: "GET",
                        headers : {
                                    'X-API-TOKEN': authentication.getCurrentUser().keycode,
                                }
                        })
                        .then(function(response){
                            if(response.data){
                                $scope.schoolList = {};
                                $scope.schoolList = response.data;
                                // console.log("schoolList", $scope.schoolList);

                                 $scope.schoolListMatch = ($scope.schoolList).filter(function(item) {
                                    return item.schoolId == $scope.editStudent.schoolId;
                                });

                            }

                        });
                    }

                    
                    //REST service to display demographic data
                    $scope.getDemographicData = function(){
                        $scope.newPartProgramList = [];
                        $scope.demoDataErrorMesg = "";
                        $scope.demoDataErrorOccurred = false;
                        $scope.noPartPermRequired = false;

                        $scope.partProgramRecords = $scope.editStudent.ssPartPrograms;
                        $scope.partProgramRecordsCopy = angular.copy( $scope.editStudent.ssPartPrograms);

                        $scope.languageInfo = $scope.editStudent.languageInfo;
                        $scope.languageInfoCopy = angular.copy($scope.editStudent.languageInfo);

                        //getLanguageList
                        $http({
                            url : schoolwork12.app.student.endpoints.getAllLanguages,
                            method: "GET",
                            headers : {
                                        'X-API-TOKEN': authentication.getCurrentUser().keycode,
                                    }
                            })
                            .then(function(response){
                                if(response.data){
                                    $scope.languagesList = angular.copy(response.data);
                                    $scope.otherFamilyLanguage = false;
                                    $scope.otherStudentLanguage = false;

                                    //familyLanguages display logic
                                    if($scope.editStudent.languageInfo.familyLanguage){
                                        var selLanguage = $scope.editStudent.languageInfo.familyLanguage;
                                        var index = _.findIndex($scope.languagesList, {name: selLanguage[0].toUpperCase() + selLanguage.slice(1).toLowerCase()}); //capitalize for matching purpose
                                        console.log("family language index", index)

                                        if($scope.editStudent.languageInfo.familyLanguage && index >= 0){
                                            $scope.languageInfo.familyLanguage = $scope.languagesList[index];
                                            $scope.languageInfo.familyLanguageCopy = angular.copy($scope.languagesList[index]);
                                        } else {
                                            $scope.languageInfo.otherFam = angular.copy($scope.editStudent.languageInfo.familyLanguage);
                                            $scope.languageInfo.otherFamCopy = angular.copy($scope.languageInfo.otherFam);

                                            $scope.languageInfo.familyLanguage = $scope.languagesList[$scope.languagesList.length - 1];
                                            $scope.otherFamilyLanguage = true;
                                        }
                                    } else {
                                        console.log("no family selection: default select")
                                    }

                                    //studentLanguages display logic
                                    if($scope.editStudent.languageInfo.studentLanguage){
                                        var selLanguage = $scope.editStudent.languageInfo.studentLanguage;
                                        var index = _.findIndex($scope.languagesList, {name: selLanguage[0].toUpperCase() + selLanguage.slice(1).toLowerCase()}); //capitalize for matching purpose
                                        console.log("student language index", index)

                                        if($scope.editStudent.languageInfo.studentLanguage && index >= 0){
                                            $scope.languageInfo.studentLanguage = $scope.languagesList[index];
                                            $scope.languageInfo.studentLanguageCopy = angular.copy($scope.languagesList[index]);
                                        } else {
                                            $scope.languageInfo.otherStu = angular.copy($scope.editStudent.languageInfo.studentLanguage);
                                            $scope.languageInfo.otherStuCopy = angular.copy($scope.languageInfo.otherStu);

                                            $scope.languageInfo.studentLanguage = $scope.languagesList[$scope.languagesList.length - 1];
                                            $scope.otherStudentLanguage = true;
                                        }
                                    } else {
                                        console.log("no student selection: default select")
                                    }
    
                                }
    
                            })

                        //getAllPartPrograms
                        manageSchoolDataSvc.getActiveSchoolPartPrograms(authentication.getCurrentUser().keycode, $scope.editStudent.schoolId)
                        .then(function (data) {
                            if(data){
                            $scope.activeSchoolPartProgramList = {};
                            $scope.activeSchoolPartProgramList = data;

                                // console.log("activeSchoolPartProgramList", $scope.activeSchoolPartProgramList)
                                for(var i =0; i < $scope.activeSchoolPartProgramList.length;i++){
                                    if($scope.activeSchoolPartProgramList[i].permRequired == 0){
                                        $scope.noPartPermRequired = true;
                                    }
                                }
                            }

                        });

                            //get CTE current and future pathways
                            $http({
                            url : schoolwork12.app.student.endpoints.studentEdit + $scope.studentRow.entity.studentId + '/cTEPathwaysXss/' + $scope.editStudent.schoolId,
                            method: "GET",
                            headers : {
                                        'X-API-TOKEN': authentication.getCurrentUser().keycode,
                                    }
                            })
                            .then(function(response){
                                // console.info("Getting CTE current and future pathways", response.data);
                                if(response.data){
                                $scope.currentCTEList = {};
                                $scope.futureCTEList = {};
                                $scope.CTEList = response.data;

                                $scope.currentCTEList = ($scope.CTEList).filter(function(item) {
                                    return item.isCurrentCte == 1;
                                });

                                $scope.futureCTEList = ($scope.CTEList).filter(function(item) {
                                    return item.isFutureCte == 1;
                                });

                                // console.log("currentCTEList", $scope.currentCTEList);
                                // console.log("futureCTEList", $scope.futureCTEList);

                                if($scope.editStudent.currentCtePathway){
                                    var index = _.findIndex($scope.currentCTEList, {displayName: $scope.editStudent.currentCtePathway.displayName});
                                    $scope.ctePathway.cteName = ($scope.editStudent.currentCtePathway.displayName && index >=0) ? $scope.currentCTEList[index] : $scope.currentCTEList[-1];

                                    var reasonIndex = _.findIndex($scope.cteReasonsList, {name: $scope.editStudent.currentCtePathway.reasonName});
                                    $scope.ctePathway.cteReason = $scope.cteReasonsList[reasonIndex];
                                }

                                if($scope.editStudent.futureCtePathway){
                                    var index2 = _.findIndex($scope.futureCTEList, {displayName: $scope.editStudent.futureCtePathway.displayName});
                                    $scope.cteFuture.futureName = ($scope.editStudent.futureCtePathway.displayName && index2 >=0) ? $scope.futureCTEList[index2] : $scope.futureCTEList[-1];

                                    var reasonIndex2 = _.findIndex($scope.futureReasonsList, {name: $scope.editStudent.futureCtePathway.reasonName});
                                    $scope.cteFuture.futureReason = $scope.futureReasonsList[reasonIndex2];

                                    $scope.cteFuture.startDate = $scope.editStudent.futureCtePathway.startDate ? new Date($scope.editStudent.futureCtePathway.startDate) : undefined;
                                }

                                $scope.ctePathwayCopy = angular.copy($scope.ctePathway);
                                $scope.cteFutureCopy = angular.copy($scope.cteFuture);

                            }

                            });

                            //getAllSchools
                            getAllSchoolsList();

                    }

                    //newly Added - Participant program
                    $scope.newPPSelected = false;
                    $scope.addProgram = function(){
                        $scope.forms.demoForm.$setDirty();
                        $scope.newPPSelected = true;

                        //default onject on adding new program
                        $scope.newPartProgramList.push({
                            abbreviation: $scope.schoolListMatch[0].abbreviation,
                            k12SchoolId: $scope.schoolListMatch[0].schoolId,
                            startDate: null,
                            endDate: null,
                        })
                    };

                    $scope.ppReasonChanged = false;
                    $scope.changePPReason = function(ppname){
                        $scope.ppReasonChanged = true;
                        for(var i =0; i < $scope.partProgramRecords[i].length;i++){
                            if($scope.ppReasonChanged){
                                $scope.partProgramRecords[i].ppReasonChanged = true;
                            } else {
                                $scope.partProgramRecords[i].ppReasonChanged = false;
                                $scope.ppReasonChanged = false;
                            }
                        }
                        // console.log("ppReasonChanged", $scope.ppReasonChanged)
                    }

                    $scope.cteNameSelected = false;
                    $scope.futureNameSelected = false;
                    $scope.changeCteName = function(cteName){
                        $scope.forms.cteForm.$setDirty();
                        $scope.cteNameSelected = true;

                        var index = _.findIndex($scope.currentCTEList, {displayName: cteName});
                        // console.log("index changeCteName", index)
                        $scope.ctePathway.cteName = $scope.currentCTEList[index];

                        if($scope.noCTEName && (!$scope.editStudent.currentCtePathway || (!$scope.editStudent.currentCtePathway
                        && !$scope.editStudent.currentCtePathway.displayName))){
                            $scope.ctePathway.cteReason =  $scope.cteNameSelected ? $scope.cteReasonsList[11] : $scope.cteReasonsList[-1];
                        }

                    }

                    $scope.changeCteReason = function(reason){
                        $scope.forms.cteForm.$setDirty();
                        var index = _.findIndex($scope.cteReasonsList, {name: reason});
                        // console.log("index changereason", index)
                        $scope.ctePathway.cteReason =  $scope.cteReasonsList[index]
                    }

                    $scope.changeFutureName = function(futureName){
                        $scope.forms.futureForm.$setDirty();
                        $scope.futureNameSelected = true;

                        var index = _.findIndex($scope.futureCTEList, {displayName: futureName});
                        // console.log("index changefutureName", index)
                        $scope.cteFuture.futureName = $scope.futureCTEList[index];

                        // console.log("changefutureName", $scope.cteFuture.futureName);
                        // console.log("selected futureName", futureName);

                        if($scope.noFutureName && (!$scope.editStudent.futureCtePathway || (!$scope.editStudent.futureCtePathway
                        && !$scope.editStudent.futureCtePathway.displayName))){
                            $scope.cteFuture.futureReason =  $scope.futureNameSelected ? $scope.futureReasonsList[5] : $scope.futureReasonsList[-1];
                        }
                    }

                    $scope.changeFutureReason = function(reason){
                        $scope.forms.futureForm.$setDirty();
                        var index = _.findIndex($scope.futureReasonsList, {name: reason});
                        // console.log("index changefuturereason", index)
                        $scope.cteFuture.futureReason =  $scope.futureReasonsList[index]
                    }

                    $scope.newPPNameChanged = false;
                    $scope.changeNewPPName = function(newPPName){
                        $scope.forms.demoForm.$setDirty();
                        $scope.newPPNameChanged = true;
                        // console.log("newPPName", newPPName, $scope.editStudent.currentCtePathway);

                        if($scope.noCTEName && (!$scope.editStudent.currentCtePathway || (!$scope.editStudent.currentCtePathway
                        && !$scope.editStudent.currentCtePathway.displayName) || !$scope.ctePathway.cteName) ){
                            for(var i =0; i < $scope.activeSchoolPartProgramList.length;i++){
                                if($scope.activeSchoolPartProgramList[i].type == 'DCA' &&
                                    $scope.activeSchoolPartProgramList[i].displayName == newPPName){
                                    // console.log("dca match");

                                    var index = _.findIndex($scope.currentCTEList, {displayName: 'Undecided'});
                                    $scope.ctePathway.cteName = $scope.currentCTEList[index];
                                    // console.log("index", index)

                                    var index2 = _.findIndex($scope.cteReasonsList, {name: 'Student enrolled in DCA program'});
                                    $scope.ctePathway.cteReason = $scope.cteReasonsList[index2];
                                    // console.log("index2", index2)

                                    $scope.forms.cteForm.$setDirty();
                                }
                            }
                        }
                    }

                    $scope.changeFamilyLanguage = function(name){
                        $scope.forms.familyLanguageForm.$setDirty();
                        $scope.familyLanguageSelected = true;

                        var index = _.findIndex($scope.languagesList, {name: name});
                        console.log("index changeFamilyLanguage", index)
                       
                        $scope.languageInfo.familyLanguage = $scope.languagesList[index];
                        console.log("$scope.languageInfo.familyLanguage", $scope.languageInfo.familyLanguage)

                    }

                    $scope.changeStudentLanguage = function(name){
                        $scope.forms.studentLanguageForm.$setDirty();
                        $scope.studentLanguageSelected = true;

                        var index = _.findIndex($scope.languagesList, {name: name});
                        console.log("index changeStudentLanguage", index)
                       
                        $scope.languageInfo.studentLanguage = $scope.languagesList[index];
                        console.log("$scope.languageInfo.studentLanguage", $scope.languageInfo.studentLanguage)

                    }


                    $scope.newSchoolChanged = false;
                    $scope.changeSchoolName = function(schoolName, record){
                        $scope.newSchoolChanged = true;
                        for(var i =0; i < $scope.newPartProgramList.length;i++){
                            if($scope.newPartProgramList[i].nonK12School && schoolName !='Non K12 Program School'){
                                $scope.newPartProgramList[i].nonK12School = '';
                            }

                            for(var j =0; j < $scope.schoolList.length;j++){
                                if($scope.newPartProgramList[i].abbreviation == $scope.schoolList[j].abbreviation){
                                   $scope.newPartProgramList[i].k12SchoolId = $scope.schoolList[j].schoolId;
                                }
                            }
                        }
                    }


                    //<!--alert dialog for leaving page without saving
                    $scope.option1 = false;
                    $scope.modalInstance1 = null;
                    $rootScope.$on('$stateChangeStart', function(event, next, current) {

                        $scope.option1 = false;
                        $scope.modalInstance1 = null;

                        if ($scope.forms.ILForm) {
                            if ($scope.forms.ILForm.$dirty || $scope.forms.SSForm.$dirty ||
                                $scope.forms.EngagementForm.$dirty || $scope.forms.FASTForm.$dirty || ($scope.forms.attdjForms && $scope.forms.attdjForms.$dirty) ||
                                ($scope.forms.demoForm.$dirty || $scope.forms.cteForm.$dirty || $scope.forms.futureForm.$dirty || $scope.forms.familyLanguageForm.$dirty || $scope.forms.studentLanguageForm.$dirty)) {
                                if (!$scope.option1) {
                                    $scope.openAlertUnsaved();
                                    event.preventDefault();
                                    $rootScope.hideStudentSearch = true;
                                }

                                $scope.modalInstance1.result.then(function(option) {
                                    $scope.reset();
                                    $scope.option1 = option;

                                    if(next.url === '/cre-tracking' || next.url === '/student-graduation-plan'){
                                        $state.go(next.name);
                                    }else {
                                        $location.url(next.url);
                                    }

                                });
                            }
                        }

                        if ($scope.$parent.studentResultsGridObject) {
                            $scope.gridPaginationSize = $scope.$parent.studentResultsGridObject.gridPageSize;
                            $timeout(function() {
                                $scope.$parent.studentResultsGridObject.grid.core.handleWindowResize();
                            });
                        }

                        if (next.url == '/student-search') {
                            // console.log("searchRevisited")
                            $scope.searchRevisited = true;
                            $location.url('/student-search');
                        }


                        //Activate the views
                        if (next.url == '/student-details') {
                            $scope.hideStudentDetails = false;
                            $rootScope.hideStudentSearch = true;
                        }

                        if (next.url == '/student-graduation-plan') {
                            $scope.hideStudentDetails = true;
                            $rootScope.hideStudentSearch = true;
                        }

                        if (next.url == '/cre-tracking') {
                            $scope.hideStudentDetails = true;
                            $rootScope.hideStudentSearch = true;
                        }

                    })

                    $scope.openAlertUnsaved = function() {
                        $scope.modalInstance1 = $uibModal.open({
                            animation: $scope.animationsEnabled,
                            templateUrl: 'commonDialog.html',
                            windowClass: 'alert-Modal',
                            keyboard: false,
                            backdrop: 'static',
                            controller: ['$scope', '$uibModalInstance',
                                function(_$scope, $uibModalInstance) {
                                    _$scope.ok = function() {
                                        $uibModalInstance.close(true);
                                    };
                                    _$scope.dialogMsg = 'You have un-saved changes on this page. Do you want to leave this page without saving the changes?';
                                    _$scope.cancel = function() {

                                      const currentUrl = document.location.href.split('/').pop();
                                      if (currentUrl == 'student-details') {
                                        $scope.hideStudentDetails = false;
                                        $rootScope.hideStudentSearch = true;
                                    }
                                        $uibModalInstance.dismiss('cancel');
                                    };
                                }
                            ],

                        });
                    };
                    //-->

                    $scope.resetForms = function() {
                        // $scope.showSavedStudentMsg = false;
                        if ($scope.forms.ILForm || $scope.forms.MTSSForm || $scope.forms.attdjForms) {
                            $scope.forms.ILForm.$setPristine();
                            $scope.forms.MTSSForm.$setPristine();
                            $scope.forms.SSForm.$setPristine();
                            $scope.forms.EngagementForm.$setPristine();
                            $scope.forms.FASTForm.$setPristine();

                            $scope.forms.demoForm.$setPristine();
                            $scope.forms.cteForm.$setPristine();
                            $scope.forms.futureForm.$setPristine();

                            $scope.forms.familyLanguageForm.$setPristine();
                            $scope.forms.studentLanguageForm.$setPristine();

                            if($scope.forms.attdjForms){
                            	$scope.forms.attdjForms.$setPristine();
                            }
                        }

                    }

                    //close success msg on click
                    $scope.closeStudentMsg = function() {
                        $scope.showSavedStudentMsg = false;
                        $scope.popUpClosed = true;
                    }

                    //Initialize navigation grid
                    $scope.gridNewOptions = {
                        enableRowSelection: false,
                        enableHorizontalScrollbar: 0,
                        enableRowHeaderSelection: false,
                        paginationPageSizes: [25, 50, 75],
                        paginationPageSize: $scope.$parent.studentResultsGridObject ?
                            $scope.$parent.studentResultsGridObject.gridPageSize : $scope.gridPaginationSize,
                        rowHeight: 50,
                        showGridFooter: false,
                    };

                    //Build column definitions
                    $scope.gridNewOptions.columnDefs = [{
                        field: 'studentId',
                        displayName: 'Student ID',
                        // width: '30%',
                        cellTemplate: '<div ng-click="grid.appScope.getStudentDetails(grid, row, true)" title="Edit Student details" class="ui-grid-cell-contents studentEdit" ng-class="{ \'savedStudentClass\': row.entity.editCompleted }" ><span >{{row.entity[col.field]}}</span></div>',
                    }, {
                        field: 'firstName',
                        cellTemplate: '<div ng-click="grid.appScope.getStudentDetails(grid, row, true)" class="ui-grid-cell-contents" style="cursor: pointer;" ng-class="{ \'savedStudentClass\': row.entity.editCompleted }" ><span >{{row.entity[col.field]}}</span></div>',

                    }, {
                        field: 'lastName',
                        cellTemplate: '<div ng-click="grid.appScope.getStudentDetails(grid, row, true)" class="ui-grid-cell-contents" style="cursor: pointer;" ng-class="{ \'savedStudentClass\': row.entity.editCompleted }" ><span >{{row.entity[col.field]}}</span></div>',

                    }];

                    $scope.gridNewOptions.data = $scope.$parent.studentResultsGridObject?$scope.$parent.studentResultsGridObject.searchResults:null;
                    $scope.gridNewOptions.multiSelect = false;
                    $scope.gridPaginationSize = $scope.$parent.studentResultsGridObject.gridPageSize;

                    $scope.gridNewOptions.onRegisterApi = function(gridApi) {
                        $scope.gridNewApi = gridApi;

                        $scope.gridNewApi.selection.on.rowSelectionChanged($scope, function(row) {
                            //get newly selected row
                            $scope.studentRow = row;
                        });
                        $scope.gridNewApi.pagination.on.paginationChanged($scope, function(pageNumber, pageSize) {
                            $scope.gridPaginationSize = pageSize;
                        });
                    };

                    //Reset student details
                    $scope.reset = function() {
                        $scope.resetForms();
                        $scope.showSavedStudentMsg = false;
                        $scope.editStudent = angular.copy($scope.currentStudent);
                        $scope.currentEditRowIndex = null;
                        $scope.isAttendanceAdjustmentSave = false;
                        $scope.isAttdjEditing = false;
                        $scope.saveDisabled = true;
                        $scope.gridAttendanceData = angular.copy($scope.currentAttAdjInfo);
                        $scope.attAdjToRemove = [];

                        $scope.newPartProgramList = [];
                        $scope.partProgramRecords = angular.copy($scope.partProgramRecordsCopy);
                        $scope.ctePathway = angular.copy($scope.ctePathwayCopy);
                        $scope.cteFuture = angular.copy($scope.cteFutureCopy);

                        if($scope.otherFamilyLanguage){
                            console.log("$scope.languageInfo OTHER Fam", $scope.languageInfo)
                            $scope.languageInfo.otherFam = angular.copy($scope.languageInfo.otherFamCopy);
                            $scope.languageInfo.familyLanguage = $scope.languagesList[$scope.languagesList.length - 1];
                        } else if($scope.editStudent.languageInfo.familyLanguage){
                            var selLanguage = $scope.editStudent.languageInfo.familyLanguage;
                            // var selLanguage = $scope.finalFamilyLanguage.name;
                            var index = _.findIndex($scope.languagesList, {name: selLanguage[0].toUpperCase() + selLanguage.slice(1).toLowerCase()}); //capitalize for matching purpose
                            $scope.languageInfo.familyLanguage = $scope.languagesList[index];
                        } else {
                            $scope.languageInfo.familyLanguage = null;
                            console.log("no family selection: default select")
                        }

                        if($scope.otherStudentLanguage){
                            console.log("$scope.languageInfo OTHER Stu", $scope.languageInfo)
                            $scope.languageInfo.otherStu = angular.copy($scope.languageInfo.otherStuCopy);
                            $scope.languageInfo.studentLanguage = $scope.languagesList[$scope.languagesList.length - 1];
                        } else if($scope.editStudent.languageInfo.studentLanguage){
                            var selLanguage = $scope.editStudent.languageInfo.studentLanguage;
                            // var selLanguage = $scope.finalStudentLanguage.name;
                            var index = _.findIndex($scope.languagesList, {name: selLanguage[0].toUpperCase() + selLanguage.slice(1).toLowerCase()}); //capitalize for matching purpose
                            $scope.languageInfo.studentLanguage = $scope.languagesList[index];
                        } else {
                            $scope.languageInfo.studentLanguage = null;
                            console.log("no student selection: default select")
                        }

                        //disable reasons on default
                        $scope.cteNameSelected = false;
                        $scope.futureNameSelected = false;
                        $scope.cteFuture.enableFFReason = false;

                        $scope.familyLanguageMesg = "";
                        $scope.studentLanguageMesg = "";
                        $scope.familyOtherLanguageError = false;
                        $scope.studentOtherLanguageError = false;

                    }

                    //Get details of selected student
                    $scope.getStudentDetails = function(grid, row, details) {
                      unsavedChanges.verify(()=>{
                        if (details)
                          $scope.gridNewApi.selection.selectRow(row.entity);
                        //check for grad plan state
                        $scope.gradPlanState = false;
                        if ($state.current.name === "studentsearch.student.gradPlan") {
                            $state.reload($state.current.name);
                            $scope.gradPlanState = true;
                            $scope.editStudent = angular.copy($scope.studentRow.entity);
                        }

                        $scope.studentedited = false;
                        $scope.savedStudent = false;

                        $scope.showSavedStudentMsg = false;
                        $scope.editErrorOccurred = false;
                        $scope.noDemoErrorsExist = true;
                        $scope.noLanguageErrorsExist = true;

                        $scope.studentRow = details ? row : $scope.$parent.studentResultsGridObject.row;
                        $scope.studentGrid = details ? grid : $scope.$parent.studentResultsGridObject.grid;

                        $scope.showPageSelected = details ? false : true;

                        creTracking.selectStudent($scope.studentRow.entity);

                        if ($scope.forms.ILForm) {
                            if ($scope.forms.ILForm.$dirty || $scope.forms.SSForm.$dirty ||
                                $scope.forms.EngagementForm.$dirty || $scope.forms.FASTForm.$dirty || ($scope.forms.attdjForms && $scope.forms.attdjForms.$dirty) ||
                                ($scope.forms.demoForm.$dirty || $scope.forms.cteForm.$dirty || $scope.forms.futureForm.$dirty) || $scope.forms.familyLanguageForm.$dirty || $scope.forms.studentLanguageForm.$dirty) {
                                $scope.studentedited = true;
                            }
                        }

                        //prompt before switching to next student
                        $scope.option2 = false;
                        $scope.modalInstance2 = null;
                        $scope.openAlertUnsavedStudent = function() {
                            $scope.modalInstance2 = $uibModal.open({
                                animation: $scope.animationsEnabled,
                                templateUrl: 'commonDialog.html',
                                windowClass: 'alert-Modal',
                                keyboard: false,
                                backdrop: 'static',
                                controller: ['$scope', '$uibModalInstance',
                                    function($scope, $uibModalInstance) {
                                        $scope.ok = function() {
                                            $uibModalInstance.close(true);
                                        };

                                        $scope.dialogMsg = 'You have un-saved changes for the current student. Do you want to continue without saving the changes?';
                                        $scope.cancel = function() {
                                            $uibModalInstance.close(false);
                                        };
                                    }
                                ],

                            });
                        };

                        //check gradPlanState
                        if (!$scope.gradPlanState) {
                            if (!$scope.studentedited) { //get student details on load
                                $scope.getStudentInfo();
                            } else {
                                if (!$scope.savedStudent) {
                                    if (!$scope.option2) { //if unsaved changes, alert prompt
                                        $scope.openAlertUnsavedStudent();
                                    }

                                    $scope.modalInstance2.result.then(function(option) {
                                        $scope.option2 = option;
                                        if (option) {
                                            // $scope.isAttdjEditing = false;
                                            $scope.getStudentInfo();
                                            $scope.ctePathway = angular.copy($scope.ctePathwayCopy);
                                            $scope.cteFuture = angular.copy($scope.cteFutureCopy);
                                            $scope.languageInfo = angular.copy($scope.languageInfoCopy);

                                        } else {
                                            //if no option is selected from modal
                                            var index = -1;
                                            var Data = $scope.gridNewOptions.data;
                                            for (var i = 0; i < $scope.gridNewOptions.data.length; i++) {
                                                if (Data[i].studentId == $scope.currentStudent.studentId) {
                                                    index = i;
                                                    $scope.gridNewApi.selection.selectRow($scope.gridNewOptions.data[i]);
                                                    break;
                                                }

                                            }

                                        }
                                    });
                                }
                            }
                        }
                      });
                    };


                    //  get student info service
                    $scope.getStudentInfo = function() {
                        $scope.isAttdjEditing = false;
                        $scope.saveDisabled = true;
                        $scope.currentEditRowIndex = null;

                        $scope.CTEPathwayErrorReason = false;
                        $scope.CTEPathwayReasonMesg = "";
                        $scope.CTEFutureErrorReason = false;
                        $scope.CTEFutureReasonMesg = "";
                        $scope.CTEPathwayErrorName = false;
                        $scope.CTEPathwayNameMesg = "";
                        $scope.CTEFutureErrorStartDate = false;
                        $scope.CTEFutureStartDateMesg = "";
                        
                        $scope.familyOtherLanguageError = false;
                        $scope.familyLanguageMesg = "";
                        $scope.studentOtherLanguageError = false;
                        $scope.studentLanguageMesg = "";

                        $scope.cteNameSelected = false;
                        $scope.futureNameSelected = false;
                        $scope.cteFuture.enableFFReason = false;

                        $rootScope.hideStudentSearch = true;
                        $scope.editStudent = angular.copy($scope.studentRow.entity);
                        getDataFieldsbyStudentSchool();
                        $http({
                            url: schoolwork12.app.student.endpoints.studentEdit + $scope.studentRow.entity.studentId,
                            method: "GET",
                            params: {
                                schoolAbbr: $scope.studentRow.entity.schoolAbbr,
                                status: $scope.studentRow.entity.status,
                                schoolId: $scope.studentRow.entity.schoolId
                            },
                            headers: {
                                'X-API-TOKEN': authentication.getCurrentUser().keycode,
                            }
                        }).then(function(response) {
                            console.info("Viewing student details");
                            $scope.editStudent = angular.extend($scope.editStudent, response.data);

                            //clear out cte objects for default select values
                            $scope.ctePathway = {};
                            $scope.cteFuture = {};

                            $scope.familyLanguage = {};
                            $scope.studentLanguage = {};
                            $scope.languageInfo = {};
                            $scope.getDemographicData();

                            if ($scope.editStudent.dateAssignedtoFAST) {
                                console.info("Assign dateAssignedtoFAST to a date object.");
                                // do this for all dates assigned to the date picker
                                $scope.editStudent.dateAssignedtoFAST = new Date($scope.editStudent.dateAssignedtoFAST);
                            }

                            if ($scope.showPageSelected) {
                                $scope.gridNewApi.pagination.seek($scope.$parent.studentResultsGridObject.currentPage);
                            }

                            //initialise current Month as selected attendance duration
                            $scope.attInfoErrorOccurred = false;

                            if($scope.hasAttendanceAdjusterRole){
                            	$timeout(function () {
                                    $scope.getAttendanceInfo();
                                }, 1200);
                                $scope.getAttAdjTotals();
                            }

                            $scope.gridNewApi.selection.selectRow($scope.studentRow.entity);
                            $scope.currentStudent = angular.copy($scope.editStudent);
                            $scope.resetForms();

                        }, function(error) {
                            console.info('Error in viewing student details....'.concat(angular.toJson(error)));
                            $scope.editErrorOccurred = true;
                            $scope.editErrorMesg = "";
                            if (error.status == 400) {
                                for (var j = 0; j < error.data._errors.length; j++) {
                                    $scope.editErrorMesg = $scope.editErrorMesg + error.data._errors[j] + "\n";
                                }
                            } else if (error.status == 401 || error.status == 403) {
                                $scope.editErrorMesg = schoolwork12.app.errorMessages.sessionExpired;
                            } else {
                                $scope.editErrorMesg = schoolwork12.app.errorMessages.internalError;
                            }

                        })
                    }

                 //REST service to display attendance adjustment information
                    $scope.getAttendanceInfo = function(){

                        $scope.attInfoErrorMesg = "";
                        $scope.attInfoErrorOccurred = false;
                        var defaultMonth = -1;
                        $scope.displayMonth = $scope.attInit ? $scope.displayMonth : defaultMonth;

                        $http({
                        url : schoolwork12.app.student.endpoints.studentAttendance + $scope.studentRow.entity.studentId,
                        method: "GET",
                        params: {
                                    schoolAbbr: $scope.studentRow.entity.schoolAbbr,
                                    status: $scope.studentRow.entity.status,
                                    displayMonth: $scope.displayMonth,
                                },
                        headers : {
                                    'X-API-TOKEN': authentication.getCurrentUser().keycode,
                                }
                        })
                        .then(function(response){
                            console.info("Getting student attendance information", response.data);

                            if (response.data.length > 0) {
                               var gridAttendanceData = response.data;

                                angular.forEach(gridAttendanceData, function(element) {
                                   if(element.startDate){
                                       //MM/dd/yyyy
                                       var _date = element.startDate.split('/');
                                       element.startDate = new Date(_date[2], _date[0]-1, _date[1]);
                                   }
                                   if(element.endDate){
                                       //MM/dd/yyyy
                                       var _date = element.endDate.split('/');
                                       element.endDate = new Date(_date[2], _date[0]-1, _date[1]);
                                   }

                               });
                               $scope.currentAttAdjInfo = angular.copy(gridAttendanceData);

                               // Removing attendance adjustment selected to be removed from the incoming results
                               angular.forEach($scope.attAdjToRemove, function(elToRemove){
                            	   angular.forEach(gridAttendanceData, function(element) {
                            		   if(elToRemove.id == element.id){
                                 		   var indexToRemove = gridAttendanceData.indexOf(element);
                                            gridAttendanceData.splice(indexToRemove, 1);
                                 	   }
                            	   });
                                });


                               $scope.gridAttendanceData = gridAttendanceData;

                               $scope.attInfoErrorMesg = "";
                               $scope.attInfoErrorOccurred = false;
                            } else {
                                $scope.gridAttendanceData = [];
                                $scope.attInfoErrorOccurred = true;
                                $scope.attInfoErrorMesg = schoolwork12.app.errorMessages.noResultsFound;
                            }
                         },
                        function(error){
                            console.info('Error in getting student attendance information...'.concat(angular.toJson(error)));
                            $scope.attInfoErrorOccurred = true;
                            $scope.attInfoErrorMesg = "";
                                if (error.status == 400) {
                                    for ( var j = 0; j < error.data._errors.length; j++) {
                                        $scope.attInfoErrorMesg = $scope.attInfoErrorMesg + error.data._errors[j] + "\n";
                                    }
                                } else if (error.status == 401 || error.status == 403) {
                                    $scope.attInfoErrorMesg = schoolwork12.app.errorMessages.sessionExpired;
                                } else {
                                    $scope.attInfoErrorMesg = schoolwork12.app.errorMessages.internalError;
                                }
                        });
                    }

                    //REST service to get attendance adjustment totals
                    $scope.getAttAdjTotals = function(){
	                	$http({
	                        url : schoolwork12.app.student.endpoints.studentAdjustAttendance + $scope.studentRow.entity.studentId + "/totals",
	                        method: "GET",
	                        params: {
	                                    schoolAbbr: $scope.studentRow.entity.schoolAbbr
	                                },
	                        headers : {
	                                    'X-API-TOKEN': authentication.getCurrentUser().keycode,
	                                }
	                        })
	                        .then(function(response){
	                            console.info("Getting student attendance totals", response.data);
	                            if (response.data) {
	                               $scope.excusedAbsDaysTotal = response.data.excusedAbsDaysTotal;
	                               $scope.markedDaysPresentTotal = response.data.markedDaysPresentTotal;
	                               $scope.attInfoErrorMesg = "";
	                               $scope.attInfoErrorOccurred = false;
	                            } else {
	                                $scope.attInfoErrorOccurred = true;
	                                $scope.attInfoErrorMesg = schoolwork12.app.errorMessages.noResultsFound;
	                            }
	                         },
	                        function(error){
	                            console.info('Error in getting student attendance totals...'.concat(angular.toJson(error)));
	                            $scope.attInfoErrorOccurred = true;
	                            $scope.attInfoErrorMesg = "";
	                                if (error.status == 400) {
	                                    for ( var j = 0; j < error.data._errors.length; j++) {
	                                        $scope.attInfoErrorMesg = $scope.attInfoErrorMesg + error.data._errors[j] + "\n";
	                                    }
	                                } else if (error.status == 401 || error.status == 403) {
	                                    $scope.attInfoErrorMesg = schoolwork12.app.errorMessages.sessionExpired;
	                                } else {
	                                    $scope.attInfoErrorMesg = schoolwork12.app.errorMessages.internalError;
	                                }
	                        });
                    }

                //initialize default settings
                $scope.attInfoErrorMesg = "";
                $scope.attInfoErrorOccurred = false;

                $scope.isAttendanceAdjustmentSave = false;
                $scope.currentEditRowIndex = null;
                $scope.currentEditStartDateDialog = null;
                $scope.currentEditEndDateDialog = null;
                $scope.isAttdjEditing = false;
                $scope.saveDisabled = true;

                $scope.attdjEditMode = function(index){
                    return index == $scope.currentEditRowIndex;
                };

                $scope.attdjEnableEditMode = function(index){
                    return (!isNaN($scope.currentEditRowIndex))?(index == $scope.currentEditRowIndex):false;
                }

                $scope.editAttendanceAdjustmentRecord = function(row, record){
                    if(!$scope.isAttdjEditing){
                        // $scope.saveDisabled = true;
                        $scope.currentEditRowIndex = row;
                        $scope.showSavedStudentMsg = false;
                        record["isEditing"] = true;
                        $scope.isAttdjEditing = true;
                        if(record._default == undefined){
                            record["_default"] = angular.copy(record);
                        }
                    }
                    $scope.forms.attdjForms.$setPristine();
                };

                $scope.removeAttendanceRecord = function(record){
                    var index = $scope.gridAttendanceData.indexOf(record);
                    $scope.attAdjToRemove.push(record);
                    $scope.gridAttendanceData.splice(index, 1);
                    $scope.saveDisabled = false;
                    $scope.forms.attdjForms.$setDirty();
                };

                $scope.confirmAttendanceAdjustmentRecord = function(row, record){
                    record["isEditing"] = false;
                    $scope.isAttdjEditing = false;
                    $scope.currentEditRowIndex = null;
                    var rawEntity = record["_default"];

                    for (var prop in record) {
                    	if(prop == 'startDate' || prop == 'endDate' || prop == 'percent' || prop == 'type' || prop == 'reason' || prop == 'excuser' || prop == 'comments'){
                    		if(rawEntity[prop]){
                    			if(!record[prop]){
                    				record["isEdited"] = true;
                    			}else{
                    				if(prop == 'startDate' || prop == 'endDate'){
                    					if($filter('date')(record[prop], 'MM/dd/yyyy') != $filter('date')(rawEntity[prop], 'MM/dd/yyyy')){
                                   			record["isEdited"] = true;
                            			}
                    				}else if(record[prop] != rawEntity[prop]){
                    					record["isEdited"] = true;
                    				}
                    			}
                    		}else if(record[prop] != null){
                    			record["isEdited"] = true;
                    		}
                    	}
                    }
                    var endDateVal = $scope.forms.attdjForms['attdjForm_' +row]["attdjEndDate_"+row].$viewValue;
                    var d = new Date(endDateVal);
    				if((endDateVal != null && endDateVal != "") && d == 'Invalid Date'){
    					record["isEdited"] = true;
    				}

                    $scope.attendanceAdjustmentDaysDiff(row, record);
                    // TODO: review this with Paula
                    // At least one edited record needs to be saved
                    if(record["isEdited"]){
                        $scope.isAttendanceAdjustmentSave = true;
                    }
                };

                $scope.cancelAttendanceAdjustmentRecord = function(row, record){
                    record["isEditing"] = false;
                    record["isEdited"] = true;
                    var rawEntity = record["_default"];
                    for (var prop in rawEntity) {
                        record[prop] = rawEntity[prop];
                    }
                    $scope.currentEditRowIndex = null;
                    $scope.isAttdjEditing = false;
                };

                // Determines the Search datepickers opening and closing
                $scope.openAttendanceAdjustmentStartDate = function(index, record) {
                    record.dpStartDate = true;
                };

                $scope.openAttendanceAdjustmentEndDate = function(index, record) {
                    record.dpEndDate = true;
                };

                $scope.openDemographicStartDate = function(index, record) {
                    record.ddStartDate = true;
                    record.enablePPReason = true;
                };

                $scope.openDemographicEndDate = function(index, record) {
                    record.ddEndDate = true;
                    record.enablePPReason = true;
                };

                $scope.openDemographicLastDate = function(index, record) {
                    record.ddLastDate = true;
                };

                $scope.openFutureStartDate = function(index, record) {
                    record.ffStartDate = true;
                    record.enableFFReason = true;
                };

                $scope.isLanguageFormValid = function(){
                    //validations for student and family language fields
                    console.info("Validating Family Language field", $scope.languageInfo.familyLanguage);
                    console.log("$scope.languageInfo.otherFamCopy", $scope.languageInfo.otherFamCopy)
                    if ($scope.languageInfo.familyLanguage && $scope.languageInfo.familyLanguage.name == 'Other' && !$scope.languageInfo.otherFam){
                        $scope.familyOtherLanguageError = true;
                        $scope.familyLanguageMesg = schoolwork12.app.student.errorMessages.FamilyLanguageErrorMesg;
                    } else {
                        $scope.familyOtherLanguageError = false;
                        $scope.familyLanguageMesg = "";
                    }

                    console.info("Validating Student Language field", $scope.languageInfo.studentLanguage);
                    if ($scope.languageInfo.studentLanguage && $scope.languageInfo.studentLanguage.name == 'Other' && !$scope.languageInfo.otherStu){
                        $scope.studentOtherLanguageError = true;
                        $scope.studentLanguageMesg = schoolwork12.app.student.errorMessages.StudentLanguageErrorMesg; 
                    } else {
                        $scope.studentOtherLanguageError = false;
                        $scope.studentLanguageMesg = "";
                    }
    
                    return !$scope.familyLanguageMesg && !$scope.studentLanguageMesg;
                }

                $scope.isDemoFormValid = function(){
                    //validations for demo data: pp/cte current/cte future fields
                    console.info("Validating CTE Pathway reason", $scope.ctePathway);
                    if ($scope.cteNameSelected && !angular.isDefined($scope.ctePathway.cteReason)){
                        $scope.CTEPathwayErrorReason = true;
                        $scope.CTEPathwayReasonMesg = schoolwork12.app.student.errorMessages.CTEPathwayReasonMesg;
                    } else {
                        $scope.CTEPathwayErrorReason = false;
                        $scope.CTEPathwayReasonMesg = "";
                    }

                    console.info("Validating CTE Future reason");
                    if (($scope.futureNameSelected || $scope.cteFuture.enableFFReason) && !angular.isDefined($scope.cteFuture.futureReason)){
                        $scope.CTEFutureErrorReason = true;
                        $scope.CTEFutureReasonMesg = schoolwork12.app.student.errorMessages.CTEPathwayReasonMesg;
                    } else {
                        $scope.CTEFutureErrorReason = false;
                        $scope.CTEFutureReasonMesg = "";
                    }

                    $scope.PartProgErrorReasonMesg = "";
                    console.info("Validating Participant Program reason");
                    for(var i =0; i < $scope.partProgramRecords.length;i++){
                        $scope.partProgramRecords[i].ppReasonError = false;
                        if($scope.partProgramRecords[i].enablePPReason && !angular.isDefined($scope.partProgramRecords[i].reasonName)){
                            $scope.partProgramRecords[i].ppReasonError = true;
                            $scope.PartProgErrorReasonMesg = schoolwork12.app.student.errorMessages.PartProgErrorReasonMesg;
                        }
                    }

                    // Validating CTE Pathway name with DCA match
                    $scope.dcaPPEndDate = false;
                    $scope.dcaNewEndDate = false;
                    $scope.dcaType = false;
                    console.info("Validating CTE Pathway name with DCA match");
                    for(var i =0; i < $scope.activeSchoolPartProgramList.length;i++){
                        for(var j =0; j < $scope.newPartProgramList.length;j++){
                            if(($scope.activeSchoolPartProgramList[i].displayName == $scope.newPartProgramList[j].displayName) &&
                                $scope.activeSchoolPartProgramList[i].type == 'DCA'){
                                $scope.dcaType = true;
                            }
                        }
                    }

                    for(var i =0; i < $scope.partProgramRecords.length;i++){
                        if($scope.partProgramRecords[i].ppEndDate == null && $scope.partProgramRecords[i].typeName== 'DCA'){
                            $scope.dcaPPEndDate = true;
                        }
                    }
                    for(var i =0; i < $scope.newPartProgramList.length;i++){
                        if($scope.newPartProgramList[i].ppEndDate == null && $scope.dcaType){
                            $scope.dcaNewEndDate = true;
                        }
                    }
                    if(($scope.dcaPPEndDate || $scope.dcaNewEndDate) && !$scope.ctePathway.cteName){
                        $scope.CTEPathwayErrorName = true;
                        $scope.CTEPathwayNameMesg = schoolwork12.app.student.errorMessages.CTEPathwayDCANameMesg;
                    } else {
                        $scope.CTEPathwayErrorName = false;
                        $scope.CTEPathwayNameMesg = "";
                    }

                    var dFStartDate = new Date($scope.cteFuture.startDate);
                    console.info("Validating CTE Future startDate", dFStartDate);
                    if ($scope.cteFuture.enableFFReason && dFStartDate == 'Invalid Date'){
                        $scope.CTEFutureErrorStartDate = true;
                        $scope.CTEFutureStartDateMesg = schoolwork12.app.student.errorMessages.CTEFutureStartDateMesg;
                    } else {
                        $scope.CTEFutureErrorStartDate = false;
                        $scope.CTEFutureStartDateMesg = "";
                    }

                    $scope.PartProgErrorNameMesg = "";
                    console.info("Validating Participant Program Name");
                    for(var i =0; i < $scope.newPartProgramList.length;i++){
                        $scope.newPartProgramList[i].ppNameError = false;
                        if($scope.newPartProgramList[i].displayName == null || $scope.newPartProgramList[i].displayName == ''){
                            $scope.PartProgErrorNameMesg = schoolwork12.app.student.errorMessages.PartProgErrorNameMesg;
                            $scope.newPartProgramList[i].ppNameError = true;
                        }
                    }

                    $scope.ppStartDateMesg = "";
                    console.info("Validating Participant Program Name startDate");
                    for(var i =0; i < $scope.partProgramRecords.length;i++){
                        $scope.partProgramRecords[i].ppStartDateError = false;
                        if($scope.partProgramRecords[i].startDate == null){
                            $scope.ppStartDateMesg = schoolwork12.app.student.errorMessages.ppStartDateMesg;
                            $scope.partProgramRecords[i].ppStartDateError = true;
                        }
                    }

                    $scope.ppInvalidStartDateMesg = "";
                    console.info("Validating Participant Program Name invalid startDate");
                    for(var i =0; i < $scope.partProgramRecords.length;i++){
                        $scope.partProgramRecords[i].ppInvalidStartDateError = false;
                        var d = new Date($scope.partProgramRecords[i].startDate);
                        if(d == 'Invalid Date'){
                            $scope.ppInvalidStartDateMesg = schoolwork12.app.student.errorMessages.ppInvalidStartDateMesg;
                            $scope.partProgramRecords[i].ppInvalidStartDateError = true;
                        }
                    }

                    $scope.ppNewStartDateMesg = "";
                    console.info("Validating New Participant Program Name startDate");
                    for(var i =0; i < $scope.newPartProgramList.length;i++){
                        $scope.newPartProgramList[i].ppStartDateError = false;
                        if($scope.newPartProgramList[i].startDate == null){
                            $scope.ppNewStartDateMesg = schoolwork12.app.student.errorMessages.ppStartDateMesg;
                            $scope.newPartProgramList[i].ppStartDateError = true;
                        }
                    }

                    $scope.ppNewInvalidStartDateMesg = "";
                    console.info("Validating New Participant Program Name invalid startDate");
                    for(var i =0; i < $scope.newPartProgramList.length;i++){
                        $scope.newPartProgramList[i].ppInvalidStartDateError = false;
                        var d = new Date($scope.newPartProgramList[i].startDate);
                        if(d == 'Invalid Date'){
                            $scope.ppNewInvalidStartDateMesg = schoolwork12.app.student.errorMessages.ppInvalidStartDateMesg;
                            $scope.newPartProgramList[i].ppInvalidStartDateError = true;
                        }
                    }

                    $scope.ppInvalidEndDateMesg = "";
                    console.info("Validating Participant Program Name invalid endDate");
                    for(var i =0; i < $scope.partProgramRecords.length;i++){
                        $scope.partProgramRecords[i].ppInvalidEndDateError = false;
                        var d = new Date($scope.partProgramRecords[i].endDate);
                        if($scope.partProgramRecords[i].endDate && d == 'Invalid Date'){
                            $scope.ppInvalidEndDateMesg = schoolwork12.app.student.errorMessages.ppInvalidEndDateMesg;
                            $scope.partProgramRecords[i].ppInvalidEndDateError = true;
                        }
                    }

                    $scope.ppNewInvalidEndDateMesg = "";
                    console.info("Validating New Participant Program Name invalid endDate");
                    for(var i =0; i < $scope.newPartProgramList.length;i++){
                        $scope.newPartProgramList[i].ppInvalidEndDateError = false;
                        var d = new Date($scope.newPartProgramList[i].endDate);
                        if($scope.newPartProgramList[i].endDate && d == 'Invalid Date'){
                            $scope.ppNewInvalidEndDateMesg = schoolwork12.app.student.errorMessages.ppInvalidEndDateMesg;
                            $scope.newPartProgramList[i].ppInvalidEndDateError = true;
                        }
                    }


                   //pp: start date <= end date
                   $scope.ppCheckEndDateMesg = "";
                    console.info("Validating PP start date <= end date");
                    for(var i =0; i < $scope.partProgramRecords.length;i++){
                        $scope.partProgramRecords[i].ppCheckEndDateError = false;
                        var dStart = new Date($scope.partProgramRecords[i].startDate);
                        var dEnd = new Date($scope.partProgramRecords[i].endDate);
                        if($scope.partProgramRecords[i].endDate && (dStart > dEnd)){
                            $scope.ppCheckEndDateMesg = schoolwork12.app.student.errorMessages.ppCheckEndDateMesg;
                            $scope.partProgramRecords[i].ppCheckEndDateError = true;
                        }
                    }

                    //new: start date <= end date
                    $scope.ppNewCheckEndDateMesg = "";
                    console.info("Validating New PP start date <= end date");
                    for(var i =0; i < $scope.newPartProgramList.length;i++){
                        $scope.newPartProgramList[i].ppCheckEndDateError = false;
                        var dStart = new Date($scope.newPartProgramList[i].startDate);
                        var dEnd = new Date($scope.newPartProgramList[i].endDate);
                        if($scope.newPartProgramList[i].endDate && (dStart > dEnd)){
                            $scope.ppNewCheckEndDateMesg = schoolwork12.app.student.errorMessages.ppCheckEndDateMesg;
                            $scope.newPartProgramList[i].ppCheckEndDateError = true;
                        }
                    }

                    $scope.PartProgErrorSchoolMesg = "";
                    console.info("Validating New Participant Program School");
                    for(var i =0; i < $scope.newPartProgramList.length;i++){
                        $scope.newPartProgramList[i].ppSchoolError = false;
                        if($scope.newPartProgramList[i].abbreviation == null || $scope.newPartProgramList[i].abbreviation == ''){
                            $scope.PartProgErrorSchoolMesg = schoolwork12.app.student.errorMessages.PartProgErrorSchoolMesg;
                            $scope.newPartProgramList[i].ppSchoolError = true;
                        }
                    }

                    $scope.PartProgErrorSchoolTextMesg = "";
                    console.info("Validating New Participant Program School Text");
                    for(var i =0; i < $scope.newPartProgramList.length;i++){
                        $scope.newPartProgramList[i].ppSchoolTextError = false;
                        if($scope.newPartProgramList[i].abbreviation == 'Non K12 Program School' && ($scope.newPartProgramList[i].nonK12School == null || $scope.newPartProgramList[i].nonK12School == '')){
                            $scope.PartProgErrorSchoolTextMesg = schoolwork12.app.student.errorMessages.PartProgErrorSchoolTextMesg;
                            $scope.newPartProgramList[i].ppSchoolTextError = true;
                        }
                    }

                    return !$scope.CTEPathwayReasonMesg && !$scope.CTEFutureReasonMesg && !$scope.CTEPathwayNameMesg && !$scope.CTEFutureStartDateMesg &&
                    !$scope.PartProgErrorNameMesg && !$scope.PartProgErrorReasonMesg &&
                    !$scope.ppStartDateMesg && !$scope.ppInvalidStartDateMesg &&
                    !$scope.ppNewStartDateMesg && !$scope.ppNewInvalidStartDateMesg &&
                    !$scope.ppInvalidEndDateMesg && !$scope.ppNewInvalidEndDateMesg &&
                    !$scope.ppCheckEndDateMesg && !$scope.ppNewCheckEndDateMesg &&
                    !$scope.PartProgErrorSchoolMesg && !$scope.PartProgErrorSchoolTextMesg;

                }

                    //  save student details service
                    $scope.saveStudentDetails = function() {
                        $scope.saveDisabled = true;

                        var isSaveStudentDetails = ($scope.forms.ILForm) ?
                            ($scope.forms.ILForm.$dirty || $scope.forms.SSForm.$dirty || $scope.forms.MTSSForm.$dirty ||
                            $scope.forms.EngagementForm.$dirty || $scope.forms.FASTForm.$dirty) : false;

                        $scope.noDemoErrorsExist = true;
                        if($scope.forms.demoForm.$dirty || $scope.forms.cteForm.$dirty || $scope.forms.futureForm.$dirty ){
                            $scope.noDemoErrorsExist = $scope.isDemoFormValid();
                            console.log("noDemoErrorsExist", $scope.noDemoErrorsExist);
                        }

                        $scope.noLanguageErrorsExist = true;
                        if($scope.forms.familyLanguageForm.$dirty || $scope.forms.studentLanguageForm.$dirty ){
                            $scope.noLanguageErrorsExist = $scope.isLanguageFormValid();
                            console.log("noLanguageErrorsExist", $scope.noLanguageErrorsExist);
                        }

                        $scope.cteNameSelected = false;
                        $scope.futureNameSelected = false;
                        $scope.cteFuture.enableFFReason = false;

                        if(isSaveStudentDetails || $scope.noDemoErrorsExist || $scope.noLanguageErrorsExist){
                            $scope.isSaveBusy = true;
                            $scope.studentRow.entity.editCompleted = false;

                            $scope.popPPFlag = false;
                            for(var i =0; i < $scope.partProgramRecords.length;i++){
                                $scope.partProgramRecords[i].status = 1;
                                if($scope.partProgramRecords[i].reasonName == 'Student mistakenly entered in program (Delete)'){
                                    $scope.popPPIndex = i;
                                    $scope.partProgramRecords[i].status = 0;
                                    $scope.popPPFlag = true;
                                    // console.log("Delete", $scope.popPPIndex)
                                }
                            }

                            for(var i =0; i < $scope.partProgramRecords.length;i++){
                                $scope.partProgramRecords[i].isEdited = false;
                                if($scope.partProgramRecords[i].enablePPReason || $scope.partProgramRecords[i].ppReasonChanged){
                                    $scope.partProgramRecords[i].isEdited = true;
                                }
                                for(var j =0; j < $scope.allReasonsList.length;j++){
                                    if($scope.allReasonsList[j].name == $scope.partProgramRecords[i].reasonName){
                                        $scope.partProgramRecords[i].reasonId = $scope.allReasonsList[j].reasonId;
                                    }
                                }
                            }

                            for(var i =0; i < $scope.newPartProgramList.length;i++){
                                $scope.newPartProgramList[i].isEdited = ($scope.newPartProgramList[i].enablePPReason || $scope.newPPNameChanged || $scope.newSchoolChanged) ? true : false;
                                for(var j =0; j < $scope.activeSchoolPartProgramList.length;j++){
                                    if($scope.activeSchoolPartProgramList[j].displayName == $scope.newPartProgramList[i].displayName){
                                        $scope.newPartProgramList[i].typeName = $scope.activeSchoolPartProgramList[j].type;
                                        $scope.newPartProgramList[i].xschPartProgId = $scope.activeSchoolPartProgramList[j].xschPartProgId;
                                        $scope.newPartProgramList[i].allowMultiple = $scope.activeSchoolPartProgramList[j].allowMultiple;
                                    }
                                }
                            }

                            var ppList = angular.copy($scope.partProgramRecords);
                            angular.forEach(ppList, function(element) {
                                element.startDate = $filter('date')(element.startDate, 'MM/dd/yyyy');
                                element.endDate = $filter('date')(element.endDate, 'MM/dd/yyyy');
                                element.reasonName = element.reasonName;
                            })

                            var newList = angular.copy($scope.newPartProgramList);
                            angular.forEach(newList, function(element) {
                                element.startDate = $filter('date')(element.startDate, 'MM/dd/yyyy');
                                element.endDate = $filter('date')(element.endDate, 'MM/dd/yyyy');
                                element.studentId = $scope.studentRow.entity.studentId;
                                element.schoolId =  $scope.editStudent.schoolId;
                            })

                            // console.log("newPartProgramList", $scope.newPartProgramList)
                            // console.log("$scope.editStudent", $scope.editStudent)
                            // console.log("$scope.partProgramRecords", $scope.partProgramRecords);
                            // console.log("ppList", ppList);
                            // console.log("newList", newList);

                            var mergedPPList = ppList.concat(newList);
                            // console.log("mergedPPList", mergedPPList);

                            // $scope.finalFamilyLanguage = angular.copy($scope.languageInfo.familyLanguage);
                            // $scope.finalStudentLanguage = angular.copy($scope.languageInfo.studentLanguage)

                           
                                $http({
                                    url: schoolwork12.app.student.endpoints.studentEdit + $scope.studentRow.entity.studentId,
                                    method: "PUT",
                                    data: {
                                        "firstName": $scope.editStudent.firstName,
                                        "lastName": $scope.editStudent.lastName,
                                        "elaInstrLvl": $scope.editStudent.elaInstrLvl,
                                        "writingInstrLvl": $scope.editStudent.writingInstrLvl,
                                        "mathInstrLvl": $scope.editStudent.mathInstrLvl,
                                        "scienceInstrLvl": $scope.editStudent.scienceInstrLvl,
                                        "ssHistoryInstrLvl": $scope.editStudent.ssHistoryInstrLvl,
                                        "learningSpace": $scope.editStudent.learningSpace,
    
                                      // "elaMtssLevelId": getMtssValue($scope.editStudent.elaMtssLevelId),
                                        "elaMtssLevelId": $scope.editStudent.elaMtssLevelId ,
                                        "mathMtssLevelId":$scope.editStudent.mathMtssLevelId,
                                        "scienceMtssLevelId": $scope.editStudent.scienceMtssLevelId,
                                        "ssHistoryMtssLevelId":$scope.editStudent.ssHistoryMtssLevelId,
    
                                        "workingComp": $scope.editStudent.workingComp,
                                        "internet": $scope.editStudent.internet,
                                        "bbclunchr": $scope.editStudent.bbclunchr,
                                        "faslCheckInCall": $scope.editStudent.faslCheckInCall,
                                        "contgncyWP": $scope.editStudent.contgncyWP,
                                        "overallAttendanceComment": $scope.editStudent.overallAttendanceComment,
                                        "dateAssignedtoFAST": $filter('date')($scope.editStudent.dateAssignedtoFAST, 'MM/dd/yyyy'),
                                        "schoolAbbr": $scope.editStudent.schoolAbbr,
                                        "status": $scope.editStudent.status,
    
                                        "currentCtePathway": {
                                            "displayName": $scope.ctePathway.cteName ? $scope.ctePathway.cteName.displayName : ($scope.editStudent.currentCtePathway ? $scope.editStudent.currentCtePathway.displayName : null),
                                            "modifiedByName": $scope.editStudent.currentCtePathway ? $scope.editStudent.currentCtePathway.modifiedByName : null,
                                            "modifyDate": $scope.editStudent.currentCtePathway ? $scope.editStudent.currentCtePathway.modifyDate : null,
                                            "reasonId": $scope.ctePathway.cteReason ? $scope.ctePathway.cteReason.reasonId : ($scope.editStudent.currentCtePathway ? $scope.editStudent.currentCtePathway.reasonId : null),
                                            "reasonName": $scope.ctePathway.cteReason ? $scope.ctePathway.cteReason.name : ($scope.editStudent.currentCtePathway ? $scope.editStudent.currentCtePathway.reasonName : null),
                                            "xschcteid": $scope.ctePathway.cteName ? $scope.ctePathway.cteName.xschcteid : ($scope.editStudent.currentCtePathway ? $scope.editStudent.currentCtePathway.xschcteid : null),
                                            "schoolId": $scope.editStudent.currentCtePathway ? $scope.editStudent.currentCtePathway.schoolId : $scope.editStudent.schoolId,
                                            "studentId": $scope.editStudent.currentCtePathway ? $scope.editStudent.currentCtePathway.studentId : $scope.studentRow.entity.studentId,
                                            "isEdited": $scope.forms.cteForm.$dirty
                                        },
    
                                        "futureCtePathway": {
                                            "id": $scope.editStudent.futureCtePathway ? $scope.editStudent.futureCtePathway.id : null,
                                            "reasonId": $scope.cteFuture.futureReason ? $scope.cteFuture.futureReason.reasonId : ($scope.editStudent.futureCtePathway ? $scope.editStudent.futureCtePathway.reasonId : null),
                                            "reasonName": $scope.cteFuture.futureReason ? $scope.cteFuture.futureReason.name : ($scope.editStudent.futureCtePathway ? $scope.editStudent.futureCtePathway.reasonName : null),
                                            "startDate": $filter('date')($scope.cteFuture.startDate, 'MM/dd/yyyy'),
                                            "modifyDate": $scope.editStudent.futureCtePathway ? $scope.editStudent.futureCtePathway.modifyDate : null,
                                            "modifiedByName": $scope.editStudent.futureCtePathway ? $scope.editStudent.futureCtePathway.modifiedByName : null,
                                            "xschcteid": $scope.cteFuture.futureName ? $scope.cteFuture.futureName.xschcteid : ($scope.editStudent.futureCtePathway ? $scope.editStudent.futureCtePathway.xschcteid : null),
                                            "displayName": $scope.cteFuture.futureName ? $scope.cteFuture.futureName.displayName : ($scope.editStudent.futureCtePathway ? $scope.editStudent.futureCtePathway.displayName : null),
                                            "schoolId": $scope.editStudent.futureCtePathway ? $scope.editStudent.futureCtePathway.schoolId : $scope.editStudent.schoolId,
                                            "studentId": $scope.editStudent.futureCtePathway ? $scope.editStudent.futureCtePathway.studentId : $scope.studentRow.entity.studentId,
                                            "isEdited": $scope.forms.futureForm.$dirty,
                                            "status": $scope.editStudent.futureCtePathway ? $scope.editStudent.futureCtePathway.status : 1
    
                                        },
                                        "ssPartPrograms": mergedPPList,
    
                                        "familyLanguage": $scope.languageInfo.familyLanguage && angular.isDefined($scope.languageInfo.familyLanguage) ? $scope.languageInfo.familyLanguage.name : null,
                                        "otherFamilyLanguage": $scope.languageInfo.familyLanguage && angular.isDefined($scope.languageInfo.familyLanguage) && $scope.languageInfo.familyLanguage.name=='Other' ? $scope.languageInfo.otherFam : null,
                                        "studentLanguage": $scope.languageInfo.studentLanguage && angular.isDefined($scope.languageInfo.studentLanguage) ? $scope.languageInfo.studentLanguage.name : null,
                                        "otherStudentLanguage": $scope.languageInfo.studentLanguage && angular.isDefined($scope.languageInfo.studentLanguage) && $scope.languageInfo.studentLanguage.name=='Other' ? $scope.languageInfo.otherStu : null,
                                    },
                                    headers: {
                                        'X-API-TOKEN': authentication.getCurrentUser().keycode,
                                    }
                                }).then(function(response) {
                                    $scope.isSaveBusy = false;
                                    $scope.editErrorOccurred = false;
                                    $scope.studentRow.entity = angular.extend($scope.studentRow.entity, $scope.editStudent);
                                    $scope.studentRow.entity.editCompleted = true;
    
                                    //refresh on save
                                    if($scope.forms.demoForm.$dirty || $scope.forms.cteForm.$dirty || $scope.forms.futureForm.$dirty){
                                        $scope.getStudentInfo();
                                    }
    
                                    $scope.showSavedStudentMsg = true;
                                    $scope.savedStudent = true;
                                    $scope.resetForms();
    
                                    console.info("View saved student details", response);
                                }, function(error) {
                                    console.info('Error in saving student details....'.concat(angular.toJson(error)));
                                    $scope.editErrorOccurred = true;
                                    $scope.showSavedStudentMsg = false;
                                    $scope.isSaveBusy = false;
    
                                    $scope.savedStudent = false;
                                    $scope.studentRow.entity.editCompleted = false;
                                    $scope.editErrorMesg = "";
    
                                    if (error.status == 400) {
                                        for (var j = 0; j < error.data._errors.length; j++) {
                                            $scope.editErrorMesg = $scope.editErrorMesg + error.data._errors[j] + "\n";
                                        }
                                    } else if (error.status == 401 || error.status == 403) {
                                        $scope.editErrorMesg = schoolwork12.app.errorMessages.sessionExpired;
                                    } else {
                                        $scope.editErrorMesg = schoolwork12.app.errorMessages.internalError;
                                    }
                                });
                       
                        }


                        if($scope.hasAttendanceAdjusterRole){
                        	if($scope.isAttendanceAdjustmentSave){
                                studentAttendanceAdjustmentSvc.updateAttendaceAdjustment($scope, $scope.gridAttendanceData, authentication.getCurrentUser().keycode,authentication.getCurrentUser().schools);
                            }

                            if($scope.attAdjToRemove.length > 0){
                            	studentAttendanceAdjustmentSvc.removeAttendaceAdjustment($scope, $scope.attAdjToRemove, authentication.getCurrentUser().keycode,authentication.getCurrentUser().schools);
                            }
                        }

                    };

                    $scope.changeDuration = function(attendanceInfo){
                        $scope.attInit = true;
                        $scope.closeAttErrorClick = false;

                        //fetch preselected display month selection and populate attendance data
                        $scope.displayMonth = attendanceInfo.displayMonth;
                        if ($scope.displayMonth ==null || $scope.displayMonth==""){
                            $scope.displayMonth = -1;
                        };
                        $scope.getAttendanceInfo();
                    }


                    $scope.closeAttNotification = function() {
                        $scope.closeAttErrorClick = true;
                    }

                    $scope.viewParticipantProgramAuditTrail = function() {
                            var student = $scope.studentRow.entity;
                            $scope.displayAuditTrailGrid = false;
                            $scope.auditTrailErrorOccurred = false;
                            $scope.attInfoErrorOccurred = false;

                            var modalInstance = $uibModal.open({
                                animation: $scope.animationsEnabled,
                                templateUrl: 'partProgramsAuditTrail.html',
                                size: 'lg',
                                backdrop: 'static',
                                controller: ['$scope', '$uibModalInstance',
                                    function($scope, $uibModalInstance) {
                                        console.log("Viewing Participant Program audit trail for selected student");
                                        $scope.gridOptions = {
                                            enableFiltering: true,
                                            enableRowSelection: true,
                                            enableGridMenu: true,
                                            exporterMenuPdf: false,
                                            enableRowHeaderSelection: true,
                                            showGridFooter: true,
                                            enableCellEditOnFocus: true,
                                            rowHeight: 50,
                                            paginationPageSizes: [10, 15, 20],
                                            paginationPageSize: 10,
                                        };

                                        //build column definitions
                                        $scope.gridOptions.columnDefs = [
                                            { field: 'action', displayName: 'Action', minWidth: 120 },
                                            { field: 'programName', displayName: 'Program Name', minWidth: 120 },
                                            { field: 'programType', displayName: 'Program Type', minWidth: 120 },
                                            { field: 'programSchool', displayName: 'Program School', minWidth: 120 },
                                            { field: 'startDate', displayName: 'Start Date', minWidth: 120 },
                                            { field: 'endDate', displayName: 'End Date', minWidth: 120 },
                                            { field: 'changeReason', displayName: 'Change Reason', minWidth: 120 },
                                            { field: 'modifyDate', displayName: 'Modify Date', minWidth: 120 },
                                            { field: 'modifiedBy', displayName: 'Modified By', minWidth: 120 },
                                        ];

                                        //  get student info service
                                        $http({
                                            url: schoolwork12.app.student.endpoints.studentEdit + student.studentId + '/partProgramsAuditTrail',
                                            method: "GET",
                                            params: {
                                                schoolId: student.schoolId
                                            },
                                            headers: {
                                                'X-API-TOKEN': authentication.getCurrentUser().keycode,
                                            }
                                        }).then(function(response) {
                                            if (response.data.length > 0) {
                                                $scope.displayAuditTrailGrid = true;
                                                $scope.gridOptions.data = response.data;
                                            } else {
                                                $scope.auditTrailErrorOccurred = true;
                                                $scope.auditTrailErrorMesg = schoolwork12.app.errorMessages.noResultsFound;
                                            }

                                        }, function(error) {
                                            console.info('Error in viewing participant program for student audit trail....'.concat(angular.toJson(error)));
                                            $scope.auditTrailErrorOccurred = true;
                                            $scope.auditTrailErrorMesg = "";
                                            if (error.status == 400) {
                                                for (var j = 0; j < error.data._errors.length; j++) {
                                                    $scope.auditTrailErrorMesg = $scope.auditTrailErrorMesg + error.data._errors[j] + "\n";
                                                }
                                            } else if (error.status == 401 || error.status == 403) {
                                                $scope.auditTrailErrorMesg = schoolwork12.app.errorMessages.sessionExpired;
                                            } else {
                                                $scope.auditTrailErrorMesg = schoolwork12.app.errorMessages.internalError;
                                            }

                                        });

                                        $scope.cancel = function() {
                                            $uibModalInstance.dismiss('cancel');
                                        };

                                        $scope.closeNotification = function() {
                                            $scope.closeClick = true;
                                        }

                                    }
                                ],

                            });
                        }


                   $scope.viewCteAuditTrail = function() {
                            var student = $scope.studentRow.entity;
                            $scope.displayAuditTrailGrid = false;
                            $scope.auditTrailErrorOccurred = false;
                            $scope.attInfoErrorOccurred = false;

                            var modalInstance = $uibModal.open({
                                animation: $scope.animationsEnabled,
                                templateUrl: 'cteAuditTrail.html',
                                size: 'lg',
                                backdrop: 'static',
                                controller: ['$scope', '$uibModalInstance',
                                    function($scope, $uibModalInstance) {
                                        console.log("Viewing CTE audit trail for selected student");
                                        $scope.gridOptions = {
                                            enableFiltering: true,
                                            enableRowSelection: true,
                                            enableGridMenu: true,
                                            exporterMenuPdf: false,
                                            enableRowHeaderSelection: true,
                                            showGridFooter: true,
                                            enableCellEditOnFocus: true,
                                            rowHeight: 50,
                                            paginationPageSizes: [10, 15, 20],
                                            paginationPageSize: 10,
                                        };

                                        //build column definitions
                                        $scope.gridOptions.columnDefs = [
                                            { field: 'action', displayName: 'Action', minWidth: 120 },
                                            { field: 'PathwayName', displayName: 'Pathway Name', minWidth: 120 },
                                            { field: 'changeReason', displayName: 'Change Reason', minWidth: 120 },
                                            { field: 'modifyDate', displayName: 'Modify Date', minWidth: 120 },
                                            { field: 'modifiedBy', displayName: 'Modified By', minWidth: 120 },
                                        ];

                                        //  get student info service
                                        $http({
                                            url: schoolwork12.app.student.endpoints.studentEdit + student.studentId + '/ctePathwayAuditTrail/current',
                                            method: "GET",
                                            params: {
                                                schoolId: student.schoolId
                                            },
                                            headers: {
                                                'X-API-TOKEN': authentication.getCurrentUser().keycode,
                                            }
                                        }).then(function(response) {
                                            if (response.data.length > 0) {
                                                $scope.displayAuditTrailGrid = true;
                                                $scope.gridOptions.data = response.data;
                                            } else {
                                                $scope.auditTrailErrorOccurred = true;
                                                $scope.auditTrailErrorMesg = schoolwork12.app.errorMessages.noResultsFound;
                                            }

                                        }, function(error) {
                                            console.info('Error in viewing CTE for student audit trail....'.concat(angular.toJson(error)));
                                            $scope.auditTrailErrorOccurred = true;
                                            $scope.auditTrailErrorMesg = "";
                                            if (error.status == 400) {
                                                for (var j = 0; j < error.data._errors.length; j++) {
                                                    $scope.auditTrailErrorMesg = $scope.auditTrailErrorMesg + error.data._errors[j] + "\n";
                                                }
                                            } else if (error.status == 401 || error.status == 403) {
                                                $scope.auditTrailErrorMesg = schoolwork12.app.errorMessages.sessionExpired;
                                            } else {
                                                $scope.auditTrailErrorMesg = schoolwork12.app.errorMessages.internalError;
                                            }

                                        });

                                        $scope.cancel = function() {
                                            $uibModalInstance.dismiss('cancel');
                                        };

                                        $scope.closeNotification = function() {
                                            $scope.closeClick = true;
                                        }

                                    }
                                ],

                            });
                        }


                   $scope.viewFutureCteAuditTrail = function() {
                            var student = $scope.studentRow.entity;
                            $scope.displayAuditTrailGrid = false;
                            $scope.auditTrailErrorOccurred = false;
                            $scope.attInfoErrorOccurred = false;

                            var modalInstance = $uibModal.open({
                                animation: $scope.animationsEnabled,
                                templateUrl: 'futureCteAuditTrail.html',
                                size: 'lg',
                                backdrop: 'static',
                                controller: ['$scope', '$uibModalInstance',
                                    function($scope, $uibModalInstance) {
                                        console.log("Viewing Future CTE audit trail for selected student");
                                        $scope.gridOptions = {
                                            enableFiltering: true,
                                            enableRowSelection: true,
                                            enableGridMenu: true,
                                            exporterMenuPdf: false,
                                            enableRowHeaderSelection: true,
                                            showGridFooter: true,
                                            enableCellEditOnFocus: true,
                                            rowHeight: 50,
                                            paginationPageSizes: [10, 15, 20],
                                            paginationPageSize: 10,
                                        };

                                        //build column definitions
                                        $scope.gridOptions.columnDefs = [
                                            { field: 'action', displayName: 'Action', minWidth: 120 },
                                            { field: 'PathwayName', displayName: 'Pathway Name', minWidth: 120 },
                                            { field: 'startDate', displayName: 'Start Date', minWidth: 120 },
                                            { field: 'changeReason', displayName: 'Change Reason', minWidth: 120 },
                                            { field: 'modifyDate', displayName: 'Modify Date', minWidth: 120 },
                                            { field: 'modifiedBy', displayName: 'Modified By', minWidth: 120 },
                                        ];

                                        //  get student info service
                                        $http({
                                            url: schoolwork12.app.student.endpoints.studentEdit + student.studentId + '/ctePathwayAuditTrail/future',
                                            method: "GET",
                                            params: {
                                                schoolId: student.schoolId
                                            },
                                            headers: {
                                                'X-API-TOKEN': authentication.getCurrentUser().keycode,
                                            }
                                        }).then(function(response) {
                                            if (response.data.length > 0) {
                                                $scope.displayAuditTrailGrid = true;
                                                $scope.gridOptions.data = response.data;
                                            } else {
                                                $scope.auditTrailErrorOccurred = true;
                                                $scope.auditTrailErrorMesg = schoolwork12.app.errorMessages.noResultsFound;
                                            }

                                        }, function(error) {
                                            console.info('Error in viewing future CTE for student audit trail....'.concat(angular.toJson(error)));
                                            $scope.auditTrailErrorOccurred = true;
                                            $scope.auditTrailErrorMesg = "";
                                            if (error.status == 400) {
                                                for (var j = 0; j < error.data._errors.length; j++) {
                                                    $scope.auditTrailErrorMesg = $scope.auditTrailErrorMesg + error.data._errors[j] + "\n";
                                                }
                                            } else if (error.status == 401 || error.status == 403) {
                                                $scope.auditTrailErrorMesg = schoolwork12.app.errorMessages.sessionExpired;
                                            } else {
                                                $scope.auditTrailErrorMesg = schoolwork12.app.errorMessages.internalError;
                                            }

                                        });

                                        $scope.cancel = function() {
                                            $uibModalInstance.dismiss('cancel');
                                        };

                                        $scope.closeNotification = function() {
                                            $scope.closeClick = true;
                                        }

                                    }
                                ],

                            });
                        }


                    $scope.viewAttendanceAdjusmentAuditTrail = function() {
                        if(!$scope.isAttdjEditing){
                            var student = $scope.studentRow.entity;
                            $scope.displayAuditTrailGrid = false;
                            $scope.auditTrailErrorOccurred = false;
                            $scope.attInfoErrorOccurred = false;

                            var modalInstance = $uibModal.open({
                                animation: $scope.animationsEnabled,
                                templateUrl: 'attendanceAuditTrail.html',
                                size: 'lg',
                                backdrop: 'static',
                                controller: ['$scope', '$uibModalInstance',
                                    function($scope, $uibModalInstance) {
                                        console.log("Viewing available audit trails for selected student");
                                        $scope.gridOptions = {
                                            enableFiltering: true,
                                            enableRowSelection: true,
                                            enableGridMenu: true,
                                            exporterMenuPdf: false,
                                            enableRowHeaderSelection: true,
                                            showGridFooter: true,
                                            enableCellEditOnFocus: true,
                                            rowHeight: 50,
                                            paginationPageSizes: [10, 15, 20],
                                            paginationPageSize: 10,
                                        };

                                        //build column definitions
                                        $scope.gridOptions.columnDefs = [
                                            { field: 'id', displayName: 'Id', minWidth: 70 },
                                            { field: 'action', displayName: 'Action', minWidth: 120 },
                                            { field: 'modifiedDate', displayName: 'Date Modified', minWidth: 120 },
                                            { field: 'startDate', displayName: 'Start Date', minWidth: 120 },
                                            { field: 'endDate', displayName: 'End Date', minWidth: 120 },
                                            { field: 'percent', displayName: 'Percent', minWidth: 120, cellFilter: 'formatPercent' },
                                            { field: 'type', displayName: 'Type', minWidth: 120 },
                                            { field: 'excuser', displayName: 'Excuser', minWidth: 120 },
                                            { field: 'reason', displayName: 'Reason', minWidth: 120 },
                                            { field: 'comments', displayName: 'Comments', minWidth: 250,
                                            cellTemplate: '<div class="ui-grid-cell-contents auditTrailComment"><div class="comment">{{row.entity.comments}}</div></div>'},
                                            { field: 'modifiedBy', displayName: 'Modified By', minWidth: 120 },
                                        ];



                                        //  get student info service
                                        $http({
                                            url: schoolwork12.app.student.endpoints.studentEdit + student.studentId + '/audittrail',
                                            method: "GET",
                                            params: {
                                                schoolAbbr: student.schoolAbbr
                                            },
                                            headers: {
                                                'X-API-TOKEN': authentication.getCurrentUser().keycode,
                                            }
                                        }).then(function(response) {
                                            if (response.data.length > 0) {
                                                $scope.displayAuditTrailGrid = true;
                                                $scope.gridOptions.data = response.data;
                                            } else {
                                                $scope.auditTrailErrorOccurred = true;
                                                $scope.auditTrailErrorMesg = schoolwork12.app.errorMessages.noResultsFound;
                                            }

                                        }, function(error) {
                                            console.info('Error in viewing student audit trail....'.concat(angular.toJson(error)));
                                            $scope.auditTrailErrorOccurred = true;
                                            $scope.auditTrailErrorMesg = "";
                                            if (error.status == 400) {
                                                for (var j = 0; j < error.data._errors.length; j++) {
                                                    $scope.auditTrailErrorMesg = $scope.auditTrailErrorMesg + error.data._errors[j] + "\n";
                                                }
                                            } else if (error.status == 401 || error.status == 403) {
                                                $scope.auditTrailErrorMesg = schoolwork12.app.errorMessages.sessionExpired;
                                            } else {
                                                $scope.auditTrailErrorMesg = schoolwork12.app.errorMessages.internalError;
                                            }

                                        });

                                        $scope.cancel = function() {
                                            $uibModalInstance.dismiss('cancel');
                                        };

                                        $scope.closeNotification = function() {
                                            $scope.closeClick = true;
                                        }

                                    }
                                ],

                            });
                        }
                    }

                    $scope.getAttendanceAdjustmentTypes = function(){
                        var getAttendanceAdjustmentTypesPromise = null;
                        var getAttendanceAdjustmentTypesSvc = function(){
                            getAttendanceAdjustmentTypesPromise =  studentAttendanceAdjustmentSvc.getAttendanceAdjustmentTypes(authentication.getCurrentUser().keycode);
                            return getAttendanceAdjustmentTypesPromise;
                        }

                        if (typeof (authentication.getCurrentUser()) != 'undefined' && authentication.getCurrentUser() != null) {
                            console.info('Keycode found. Making a call to service');
                            //invoking getAttendanceAdjustmentTypesSvc()
                            return getAttendanceAdjustmentTypesSvc();
                        } else {
                            console.info('Key code not found. Using time out function to make a call');
                            $timeout(function () {
                            //invoking getAttendanceAdjustmentTypesSvc()
                            return getAttendanceAdjustmentTypesSvc();
                            }, 500);
                        }
                    };



                    $scope.getAttendanceAdjustmentReasons = function(){
                        var getAttendanceAdjustmentReasonsPromise = null;
                        var getAttendanceAdjustmentReasonsSvc = function(){
                            getAttendanceAdjustmentReasonsPromise =  studentAttendanceAdjustmentSvc.getAttendanceAdjustmentReasons(authentication.getCurrentUser().keycode);
                            return getAttendanceAdjustmentReasonsPromise;
                        }

                        if (typeof (authentication.getCurrentUser()) != 'undefined' && authentication.getCurrentUser() != null) {
                            console.info('Keycode found. Making a call to service');
                            //invoking getAttendanceAdjustmentReasonsSvc()
                            return getAttendanceAdjustmentReasonsSvc();
                        } else {
                            console.info('Key code not found. Using time out function to make a call');
                            $timeout(function () {
                            //invoking getAttendanceAdjustmentReasonsSvc()
                            return getAttendanceAdjustmentReasonsSvc();
                            }, 500);
                        }
                    };


                    if($scope.hasAttendanceAdjusterRole){
                    	var getAttendanceAdjustmentTypesPromise = $scope.getAttendanceAdjustmentTypes();

                        getAttendanceAdjustmentTypesPromise.then(
                            function (data) {
                                console.info("Providing list of attendance adjustment types");
                                $scope.attendanceAdjustmentTypes = data;
                            }

                        );

                        var getAttendanceAdjustmentReasonsPromise = $scope.getAttendanceAdjustmentReasons();

                        getAttendanceAdjustmentReasonsPromise.then(
                            function (data) {
                                console.info("Providing list of attendance adjustment reasons");
                                $scope.attendanceAdjustmentReasons = data;
                            }

                        );
                    }

                    $scope.attendanceAdjustmentDaysDiff = function(row, record){
                        var startDate = record.startDate;
                        var endDate = record.endDate;
                        var percent = record.percent/100;
                        if(endDate != null  && startDate != null){
                            var timeDiff = Math.abs(endDate.getTime() - startDate.getTime());
                            var diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));

                            var days = (diffDays+1) * percent;
                            record.days = $filter('number')(days, '2');
                        }
                    }

                    $scope.setStartDate = function(row, record){
                        return $scope.forms.attdjForms['attdjForm_' +row]["attdjStartDate_"+row].$viewValue;
                    }

                    $scope.setEndDate = function(row, record){
                        return $scope.forms.attdjForms['attdjForm_' +row]["attdjEndDate_"+row].$viewValue;
                    }

                    $scope.canDoActions = function(){
                        /*student.status
                        * * 0 = withdrawn
                        * * 1 = active
                        */
                        return authentication.hasAttendanceAdjusterRole() && $scope.student.status!=0;
                    }

                    $scope.isStudentCrePathwayShown = function (){
                        return $state.current.name === "studentsearch.student.cre"
                    }

                    $scope.isStudentDetailsShown = () => {
                        return $state.current.name === "studentsearch.student"
                    }

                    $scope.isStudentGradPlanShown = () => {
                        return $state.current.name === "studentsearch.student.gradPlan"
                    }

                }
            ]


        )
        .filter('formatPercent', function() {
            return function(input) {
                if (isNaN(input))
                    return input;
                else {
                    return input + "%";
                }
            };
        }).filter('isValidDate', function() {
            return function(input) {
                return angular.isDate(input);
            };
        });

}(angular, schoolwork12));

